import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FlightOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FlightOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M16.2553 20.4841C16.1458 20.4841 16.0353 20.4708 15.9262 20.4432L12.2524 19.5228L8.63579 20.4432C8.22897 20.5461 7.8069 20.4546 7.47629 20.1964C7.14664 19.9392 6.95752 19.5514 6.95752 19.1331V18.3414C6.95752 17.9365 7.13711 17.5564 7.44961 17.2991L10.0039 15.1926L9.96723 14.3075H3.62006C2.87549 14.3075 2.27002 13.7016 2.27002 12.9575V12.0733C2.27002 11.5093 2.62587 11.0005 3.15512 10.8052L9.96248 8.48242V5.88048C9.96248 5.2269 10.235 4.59523 10.7104 4.14743C11.1777 3.70727 11.7775 3.47384 12.4187 3.52148C12.9812 3.55483 13.5134 3.79206 13.9173 4.19031C14.3594 4.64191 14.5971 5.22214 14.5971 5.83475V15.226L17.1119 17.2991C17.4239 17.5564 17.6035 17.9365 17.6035 18.3414V19.1332C17.6035 19.5514 17.4144 19.9392 17.0847 20.1964C16.8432 20.3851 16.5526 20.4841 16.2553 20.4841ZM8.42046 19.1227L8.42094 19.1331C8.42094 19.1293 8.42094 19.1265 8.42046 19.1227ZM3.73343 12.8441H10.0759C10.8204 12.8441 11.4259 13.45 11.4259 14.1941V15.2793C11.4259 15.6842 11.2468 16.0643 10.9343 16.3216L8.37997 18.4281L8.41284 18.9902L11.9518 18.1032C12.1662 18.0499 12.3939 18.0499 12.6082 18.1032L16.1401 18.9883V18.3948L13.6253 16.3216C13.3133 16.0653 13.1337 15.6852 13.1337 15.2793V5.83473C13.1337 5.60702 13.0441 5.3898 12.8807 5.22307C12.784 5.12779 12.6001 4.99822 12.3319 4.98299C12.1009 4.96869 11.8846 5.05063 11.7141 5.2126C11.5307 5.38504 11.4259 5.62895 11.4259 5.88047V8.56435C11.4259 9.13028 11.0691 9.63904 10.5379 9.83245L3.73342 12.1543L3.73343 12.8441ZM9.96248 14.1941C9.96248 14.197 9.96248 14.2008 9.96296 14.2036L9.96248 14.1941Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.92 14.3075H13.8654C13.6024 14.3075 13.36 14.1665 13.2299 13.9388C13.0999 13.7101 13.1018 13.43 13.2356 13.2032C13.2642 13.1547 13.3152 13.088 13.3542 13.048C13.4171 12.9679 13.54 12.885 13.7634 12.7364C14.3046 12.3753 15.5717 11.5312 15.5717 10.5308C15.5717 10.365 15.5598 10.1992 15.5303 10.0354C15.4846 9.7829 15.5756 9.52376 15.7694 9.35417C15.9638 9.18553 16.233 9.12932 16.4773 9.2103L21.3544 10.7985C21.9104 10.9976 22.27 11.5093 22.27 12.0771V12.9574C22.27 13.7015 21.6645 14.3075 20.92 14.3075ZM15.971 12.8441H20.8066V12.159L17.0071 10.9214C16.8951 11.6979 16.4621 12.3391 15.971 12.8441Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.8926 11.1692C17.8178 11.1692 17.7416 11.1577 17.6664 11.1329L13.6391 9.82293C13.2547 9.69812 13.0446 9.28558 13.1694 8.90067C13.2942 8.51767 13.7053 8.30521 14.0917 8.43192L18.1189 9.74194C18.5033 9.86675 18.7134 10.2793 18.5886 10.6642C18.4881 10.9729 18.2013 11.1692 17.8926 11.1692Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FlightOutlineIcon;
